export type TVesselsLastSignalSliceState = {
	vesselsLastSignalData: TVesselInfo | null;
	vesselsLastSignalLoading: boolean;
	vesselsLastSignalError: Error | null;
};

export type TVesselLastVoyagesSliceState = {
	vesselLastVoyagesData: TVesselInfo | null;
	vesselLastVoyagesLoading: boolean;
	vesselLastVoyagesError: Error | null;
};

export type TVesselLastStoppageEventsSliceState = {
	vesselLastStoppageEventsData: TVesselInfo | null;
	vesselLastStoppageEventsLoading: boolean;
	vesselLastStoppageEventsError: Error | null;
};

export type TVesselLastPortCallsSliceState = {
	vesselLastPortCallsData: TVesselInfo | null;
	vesselLastPortCallsLoading: boolean;
	vesselLastPortCallsError: Error | null;
};

export type TVesselOngoingVoyageSignalsSliceState = {
	vesselOngoingVoyageSignalsData: TVesselInfo | null;
	vesselOngoingVoyageSignalsLoading: boolean;
	vesselOngoingVoyageSignalsError: Error | null;
};

export type TVesselVoyageDailySignalsSliceState = {
	vesselVoyageDailySignalsData: TVesselInfo | null;
	vesselVoyageDailySignalsLoading: boolean;
	vesselVoyageDailySignalsError: Error | null;
};

export type TVesselDailyPositionsSliceState = {
	vesselDailyPositionsData: TVesselInfo | null;
	vesselDailyPositionsLoading: boolean;
	vesselDailyPositionsError: Error | null;
};

export type TVesselOngoingVoyageDailySignalsSliceState = {
	vesselOngoingVoyageDailySignalsData: TVesselInfo | null;
	vesselOngoingVoyageDailySignalsLoading: boolean;
	vesselOngoingVoyageDailySignalsError: Error | null;
};

export type TDateRangeSliceState = {
	dateRangeData: TDateRange | null;
	dateRangeLoading: boolean;
	dateRangeError: Error | null;
};

export type TDetailedPolygonsSliceState = {
	detailedPolygonsData: TDetailedPolygons | null;
	detailedPolygonsLoading: boolean;
	detailedPolygonsError: Error | null;
};

export type TVesselCurrentStatusState = {
	vesselCurrentStatusData: TVesselCurrentStatus | null;
	vesselCurrentStatusLoading: boolean;
	vesselCurrentStatusError: Error | null;
};

export type TVesselInfo = {
	type: string
	features: TFeature[]
} | null;

export type TVoyagesInfo = {
	type: string
	features: TFeature[]
}

export type TDetailedPolygons = {
	type: string
	features: TFeature[]
}

export type TFeature = {
	type: string
	properties: TProperties | null
	geometry: TGeometry
}

export type TProperties = {
	id: string
	imoNumber: number
	vesselName: string
	sectorId: number
	sectorName: string
	color: string,
	order: number,
	heading: number,
	longitude: number
	latitude: number
	voyageId: number
	vesselActivity: string
	isInSanctionArea: boolean
	portName: string
	detailedPoligonType: string
	portActivity: string
	signalActivity: string
	timestamp: Date
	originEndTime: Date
	destinationStartTime: Date
	reportedDestination: string
	reportedEta: Date
	originName: string
	destinationName: string
	startTime: Date
	endTime: Date
	totalTimeInPort: number
	region: string
	country: string
	polygonType: string
	lastSpeed: number
}

export type TGeometry = {
	type: string
	coordinates: any
}

export type TSectorColourInfo = {
	colour: string
	sectorName: string
	active: boolean
}

export type TPointSummary = {
	id?: string;
	type: string;
	name?: string;
	timestamp?: Date;
	longitude: number;
	latitude: number;
	reportedDestination?: string;
	reportedEta?: Date
	portActivity?: string
	portName?: string
	startTime?: Date
	endTime?: Date
	totalTimeInPort?: number
	pointType?: EPointType,
	region?: string
	country?: string
	polygonType?: string
} | null;

export enum EPointType {
	VESSEL_LAST_POINT,
	VESSEL_DAILY_POINT,
	VOYAGE,
	PORT_CALL,
	STOPPAGE_EVENT,
	POLYGON
}

export type TVoyageSummary = {
	originEndTime?: Date
	destinationStartTime?: Date
	originName?: string
	destinationName?: string
	longitude: number;
	latitude: number;
} | null;

export type TDateRange = {
	startDate: string;
	endDate: string;
};

export type TVesselCurrentStatus = {
	id: string,
	imoNumber: number,
	heading: number | null,
	timestamp: Date | null,
	longitude: number | null,
	latitude: number | null,
	reportedDestination: string | null,
	reportedEta: Date | null,
	ladenCount: number | null
}

// Slice name in the ...Slice.ts file
export const VESSELS_LAST_SIGNAL = 'vesselsLastSignal';
export const VESSEL_LAST_VOYAGES = 'vesselLastVoyages';
export const VESSEL_LAST_STOPPAGE_EVENTS = 'vesselLastStoppageEvents';
export const VESSEL_LAST_PORT_CALLS = 'vesselLastPortCalls';
export const VESSEL_ONGOING_VOYAGE_SIGNALS = 'vesselOngoingVoyageSignals';
export const VESSEL_VOYAGE_DAILY_SIGNALS = 'vesselVoyageDailySignals';
export const VESSEL_DAILY_POSTIONS = 'vesselDailyPositions';
export const VESSEL_ONGOING_VOYAGE_DAILY_SIGNALS = 'vesselOngoingVoyageDailySignals';
export const DATE_RANGE = 'dateRange';
export const DETAILED_POLYGONS = 'detailedPolygons';
export const VESSEL_CURRENT_STATUS = 'vesselCurrentStatus';

// Action types
export const actionTypes = {
	GET_VESSELS_LAST_SIGNAL_REQUEST: `${VESSELS_LAST_SIGNAL}/getVesselsLastSignalRequestAction`,
	GET_VESSEL_LAST_VOYAGES_REQUEST: `${VESSEL_LAST_VOYAGES}/getVesselLastVoyagesRequestAction`,
	GET_VESSEL_LAST_STOPPAGE_EVENTS_REQUEST: `${VESSEL_LAST_STOPPAGE_EVENTS}/getVesselLastStoppageEventsRequestAction`,
	GET_VESSEL_LAST_PORT_CALLS_REQUEST: `${VESSEL_LAST_PORT_CALLS}/getVesselLastPortCallsRequestAction`,
	GET_VESSEL_ONGOING_VOYAGE_SIGNALS_REQUEST: `${VESSEL_ONGOING_VOYAGE_SIGNALS}/getVesselOngoingVoyageSignalsRequestAction`,
	GET_VESSEL_VOYAGE_DAILY_SIGNALS_REQUEST: `${VESSEL_VOYAGE_DAILY_SIGNALS}/getVesselVoyageDailySignalsRequestAction`,
	GET_VESSEL_DAILY_POSITIONS_REQUEST: `${VESSEL_DAILY_POSTIONS}/getVesselDailyPositionsRequestAction`,
	GET_VESSEL_ONGOING_VOYAGE_DAILY_SIGNALS_REQUEST: `${VESSEL_ONGOING_VOYAGE_DAILY_SIGNALS}/getVesselOngoingVoyageDailySignalsRequestAction`,
	GET_DATE_RANGE_REQUEST: `${DATE_RANGE}/getDefaultActivityDateRangeRequestAction`,
	GET_DETAILED_POLYGONS_REQUEST: `${DETAILED_POLYGONS}/getDetailedPolygonsRequestAction`,
	GET_VESSEL_CURRENT_STATUS_REQUEST: `${VESSEL_CURRENT_STATUS}/getVesselCurrentStatusRequestAction`,
};